var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.633,
    height: 13.335,
    viewBox: "0 0 12.633 13.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5762",
    "data-name": "Group 5762",
    transform: "translate(4027 3339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    d: "M105.7,91.009h8.422a.7.7,0,0,0,.7-.7V88.2a.7.7,0,0,0-.7-.7H105.7a.7.7,0,0,0-.7.7v2.105A.7.7,0,0,0,105.7,91.009Z",
    transform: "translate(-4130.596 -3422.991)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M107.105,192.5h-1.4a.7.7,0,0,0-.7.7v1.4a.7.7,0,0,0,.7.7h1.4a.7.7,0,0,0,.7-.7v-1.4A.7.7,0,0,0,107.105,192.5Z",
    transform: "translate(-4130.596 -3522.78)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M282.105,192.5h-1.4a.7.7,0,0,0-.7.7v1.4a.7.7,0,0,0,.7.7h1.4a.7.7,0,0,0,.7-.7v-1.4A.7.7,0,0,0,282.105,192.5Z",
    transform: "translate(-4298.578 -3522.78)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    d: "M81.229,0H71.4A1.408,1.408,0,0,0,70,1.4V11.931a1.408,1.408,0,0,0,1.4,1.4h9.826a1.408,1.408,0,0,0,1.4-1.4V1.4A1.408,1.408,0,0,0,81.229,0Zm-.351,1.053a.351.351,0,1,1-.351.351A.351.351,0,0,1,80.878,1.053Zm-1.4,0a.351.351,0,1,1-.351.351A.351.351,0,0,1,79.475,1.053Zm2.456,10.878a.7.7,0,0,1-.7.7H71.4a.7.7,0,0,1-.7-.7V2.807H81.931Z",
    transform: "translate(-4097 -3339)",
    fill: "#091b49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.1c5481a127a3bf44fe5174c3374240a1.svg";
export { ForwardRef as ReactComponent };